import React from "react";

import { Button, Toggle, Card } from "selfly-ui-react";

import alterTree from '../../../utils/alterTree';

import "./DeviceFilteringSelector.scss";

export default class DeviceFilteringSelector extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            params: {
                severity: {
                    negative: false,
                    values: [],
                },
                devicesWithAlarms: {
                    value: false,
                },
                devicesWithAlarms2: {
                    value: 0,
                },
                online: {
                    value: "both",
                },
                deviceType: {
                    negative: false,
                    values: [],
                },
            },
        };
        this.filterRuleBuilder();
    }

    updateState = (target, value) => {
        this.setState(alterTree(this.state, target, value), this.filterRuleBuilder);
    };

    filterRuleBuilder = () => {
        const { devicesWithAlarms, online, deviceType } = this.state.params;
        const rules = [];
        // {key: "alerts", rule: (it) => it.length > 0, description: "Has alerts"}

        // Severity rule, DO NOT WORK YET.
        // if(severity.values.length > 0) {
        //     rules.push({
        //         key: "severity",
        //         rule: (sev) => {
        //             const vals = { "low": [0, 0.3], "medium": [0.3, 0.6], "high": [0.6, 0.8], "critical": [0.8, 1]};
        //             return severity.reduce((a, c) => {
        //                 if(a === true) return a;
        //                 return (sev >= vals[c][0] && sev <= vals[c][1]);
        //             }, false);

        //         },
        //         not: severity.negative
        //     });
        // }

        // DevicesWith Alarms
        if (devicesWithAlarms.value === true) {
            rules.push({
                key: "alerts",
                rule: it => it.length > 0,
            });
        }

        // Device Type
        if (deviceType.values.length > 0) {
            rules.push({
                key: "type",
                rule: "is",
                value: deviceType.values,
                not: deviceType.negative,
                nonCaseSensitive: true,
            });
        }

        // Online rule
        if (online.value !== "both") {
            rules.push({
                key: "isOnline",
                rule: "is",
                value: online.value === "online" ? true : false,
            });
        }

        this.props.onChange(rules);
    };

    render() {
        return (
            <div className="device-filtering-selector">
                {/* <Accordion icon="filter_list" title={`Device Filter testing`}> */}
                <Card title="Filters">
                    <FilterRule
                        name="Has alarms"
                        help="Include only those devices that has alarms, either active or resolved"
                        type="toggle"
                        stateKey="params.devicesWithAlarms"
                        value={this.state.params.devicesWithAlarms.value}
                        onChange={(key, value) => this.updateState(key, value)}
                    />

                    <FilterRule
                        name="Has alarms 2"
                        help="What alarms does the device have"
                        type="radioButtons"
                        stateKey="params.devicesWithAlarms2"
                        value={this.state.params.devicesWithAlarms2.value}
                        onChange={(key, value) => this.updateState(key, value)}
                        buttons={[
                            { text: "OFF", value: 0, type: "negative" },
                            { text: "No alarms", value: 1 },
                            { text: "Any alarms", value: 2 },
                            { text: "Active alarms", value: 3 },
                        ]}
                    />

                    <FilterRule
                        show={false}
                        name="Alarm levels"
                        help="Which severity levels are show."
                        type="checkboxButtons"
                        negative={this.state.params.severity.negative}
                        buttons={[
                            {
                                text: "Critical",
                                value: "critical",
                            },
                            {
                                text: "High",
                                value: "high",
                            },
                            {
                                text: "Medium",
                                value: "medium",
                            },
                            {
                                text: "Low",
                                value: "low",
                            },
                        ]}
                        stateKey="params.severity"
                        value={this.state.params.severity.values}
                        onChange={(key, value) => this.updateState(key, value)}
                    />

                    <FilterRule
                        name="Device status"
                        help="Filter devices based on if they appear offline or online"
                        type="radioButtons"
                        buttons={[
                            { text: "Both", value: "both" },
                            { text: "ONLINE", value: "online" },
                            { text: "OFFLINE", value: "offline" },
                        ]}
                        value={this.state.params.online.value}
                        stateKey="params.online"
                        onChange={(key, value) => this.updateState(key, value)}
                    />

                    <FilterRule
                        name="Device type"
                        help="Select the devices types shown."
                        type="checkboxButtons"
                        negative={this.state.params.deviceType.negative}
                        buttons={[
                            {
                                text: "Intelligent Cabinet",
                                value: "smartCabinet",
                            },
                            {
                                text: 'Encoding Station',
                                value: 'encodingstation',
                            },
                        ]}
                        stateKey="params.deviceType"
                        value={this.state.params.deviceType.values}
                        onChange={(key, value) => this.updateState(key, value)}
                    />
                {/* </Accordion> */}
                </Card>
            </div>
        );
    }
}

function FilterRule(props) {
    if (props.show === false) {
        return null;
    }

    const changeRule = (key, value) => {
        // console.log("Change Rule:", key, value);
        props.onChange(key, value);
    };

    return (
        <div className="filter-rule">
            <div className="filter-rule-body">
                <div className="filter-rule-name">
                    <h4>{props.name}</h4>
                </div>
                <div className="filter-rule-reverse">
                    {props.negative !== undefined && (
                        <Button
                            type={props.negative ? "negative" : "positive"}
                            size="md"
                            onClick={val => changeRule(`${props.stateKey}.negative`, !props.negative)}
                        >
                            {props.negative ? "IS NOT" : "IS"}
                        </Button>
                    )}
                </div>
                <div className="filter-rule-content">
                    {props.type === "checkboxButtons" && (
                        <FilterRuleCheckboxButtons
                            buttons={props.buttons}
                            onClick={changeRule}
                            stateKey={`${props.stateKey}.values`}
                            values={props.value}
                        />
                    )}
                    {props.type === "toggle" && (
                        <FilterRuleToggle
                            onClick={changeRule}
                            stateKey={`${props.stateKey}.value`}
                            value={props.value}
                        />
                    )}
                    {props.type === "radioButtons" && (
                        <FilterRuleRadioButtons
                            buttons={props.buttons}
                            onClick={changeRule}
                            stateKey={`${props.stateKey}.value`}
                            value={props.value}
                        />
                    )}
                </div>
            </div>
            <div className="filter-rule-help">
                <p>{props.help}</p>
            </div>
        </div>
    );
}

function FilterRuleCheckboxButtons(props) {
    const values = Array.isArray(props.values) ? props.values : [];

    function click(value) {
        const vind = values.findIndex(v => v === value);
        if (vind > -1) {
            props.onClick(props.stateKey, values.filter(v => v !== value));
        } else {
            props.onClick(props.stateKey, [...values, value]);
        }
    }

    function valueSelected(val) {
        return values.find(v => v === val) !== undefined;
    }

    return (
        <div className="filter-rule-checkbox-buttons">
            {props.buttons &&
                props.buttons.map((btn, i) => (
                    <Button
                        key={i}
                        value={btn.value}
                        type={valueSelected(btn.value) ? "positive" : "secondary"}
                        onClick={val => click(btn.value)}
                    >
                        {btn.text}
                    </Button>
                ))}
        </div>
    );
}

function FilterRuleRadioButtons(props) {
    function click(value) {
        props.onClick(props.stateKey, value);
    }

    return (
        <div className="filter-rule-checkbox-buttons">
            {props.buttons &&
                props.buttons.map((btn, i) => (
                    <Button
                        key={i}
                        value={btn.value}
                        type={btn.value === props.value ? (btn.type ? btn.type : "positive") : "secondary"}
                        onClick={val => click(btn.value)}
                    >
                        {btn.text}
                    </Button>
                ))}
        </div>
    );
}

function FilterRuleToggle(props) {
    function click(value) {
        // console.log("value", value);
        props.onClick(props.stateKey, value);
    }

    return (
        <div className="filter-rule-toggle">
            <Toggle isActive={props.value} onChange={val => click(val)} />
        </div>
    );
}
